import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomMaterialModule } from "./material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { CdkModule } from "./cdk.module";
import { TextMaskModule } from "../directives/angular2TextMask";

@NgModule({
  imports: [
    CustomMaterialModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    CdkModule,
    TextMaskModule
  ],
  exports: [
    CustomMaterialModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    CdkModule,
    TextMaskModule
  ],
})
export class CoreModule {}
